import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { TbLoader } from "react-icons/tb";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { RxEyeOpen, RxEyeNone } from "react-icons/rx";
//
import { loginAAAPVER, loginShipper, loginAgente } from "../../../helpers/Api";
import useToggle from '../../../hooks/UseToggle.js';
import { AppContext } from "../../../context";
import logoAAAPver from "../../../assets/Images/pie_logo.jpg";


const Login = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState('agente aduanal');
  const [passwordShown, setPasswordShown] = useToggle();
  const { dispatch } = useContext(AppContext);

  const initialValues={
    username: '',
    password: '',
  }
  

  const handleLoginAgente = async (e, setSubmitting) => {
    if (e.username !== "" || e.password !== "") {
      try {
        const response = await loginAgente(e.username, e.password);

        if (response.token) {
          dispatch({ type: "OPEN_AUTH" });
          navigate("/");
        }

        if(response.status === 400){
          Swal.fire(
          "¡Ups!",
          "Nombre de Usuario o Contraseña Incorrecta",
          "error"
        );
        }

        if(response.status === 403){
          Swal.fire(
          "¡Ups!",
          "El usuario no ha podido iniciar sesión, debido a que el convenio ha sido dado de baja",
          "error"
        );
        }

        setSubmitting(false);
      } catch (err) {
        Swal.fire(
          "¡Ups!",
          "Ha sucedido un error de conexión",
          "error"
        );
        setSubmitting(false);
      }
    } else {
      Swal.fire("¡Ups!", "Los campos deben estar llenos", "error");
    }
  };

  const handleNaviera = async (e, setSubmitting) => {
    if (e.username !== "" || e.password !== "") {
      try {
        const response = await loginShipper(e.username, e.password);
        if (response.token) {
          dispatch({ type: "OPEN_AUTH" });
          navigate("/");
          setSubmitting(false);
        }
      } catch (err) {
        Swal.fire(
          "¡Ups!",
          "Nombre de Usuario o Contraseña Incorrecta",
          "error"
        );
        setSubmitting(false);
      }
    } else {
      Swal.fire("¡Ups!", "Los campos deben estar llenos", "error");
    }
  };


  const handleLoginAAAPVER = async (e, setSubmitting) => {
    if (e.username !== "" || e.password !== "") {
      try {
        const response = await loginAAAPVER(e.username, e.password);
        if (response.token) {
          dispatch({ type: "OPEN_AUTH" });
          navigate("/");
          setSubmitting(false);
        }
      } catch (err) {
        Swal.fire(
          "¡Ups!",
          "Nombre de Usuario o Contraseña Incorrecta",
          "error"
        );
        setSubmitting(false);
      }
    } else {
      Swal.fire("¡Ups!", "Los campos deben estar llenos", "error");
    }
  };

  return (
      <div className="row login_background">
        <div className="col-12 d-flex justify-content-center">
          <div className="card login_card">
            <div className="row">
              <div className="col-12 d-flex justify-content-center">
                <img src={logoAAAPver} alt="Logo de AAAPVER" />
              </div>
              <div className="col-12 login_title">
                <h5 style={{color: '#4A70F4'}}>¡Hola {role}!</h5>
                <p>Ingresa el usuario y contraseña</p>
              </div>
              <Formik
              initialValues={initialValues}
              validationSchema={
                Yup.object({
                  username: Yup.string()
                            .required('Campo requerido'),
                  password: Yup.string()
                            .required('Campo requerido'),
                })
              }
              onSubmit={(values, { setSubmitting }) => { 
                role === 'agente aduanal' ? handleLoginAgente(values, setSubmitting) :
                role === 'miembro AAAPVER' ? handleLoginAAAPVER(values, setSubmitting) :
                handleNaviera(values, setSubmitting);
              }}
         >
          {(props) => (
          <Form>
              <div className="login_card_input">
                <div className="col-12">
                  <label htmlFor="username" className="form-label">
                    Usuario
                  </label>
                    <Field
                    type="text"
                    name="username"
                    className="form-control"
                  />
                    <ErrorMessage name="username" component="p" className="requiredField" style={{marginTop: '1rem'}} />
                </div>
                <div className="input-group">
                  <label htmlFor="password" className="input-group form-label">
                    Contraseña
                  </label>
                  <Field
                  type={passwordShown ? "text" : "password"}
                  name="password"
                  data-toggle="password"
                  className="form-control mb-3"
                  style={{borderRadius: '5px 0px 0px 5px'}}
                />
                <div className="input-group-text mb-3">
                  <i onClick={() => setPasswordShown()}>
                    {passwordShown === false && (
                      <RxEyeNone  />
                    )}
                    {passwordShown === true && (
                      <RxEyeOpen  />
                    )}
                  </i>
                  </div>
              </div>
              <div>
              <ErrorMessage name="password" component="p" className="requiredField" />
              </div>
              <br />
            <div style={{ textAlign: "center" }}>
              <button
                type="submit"
                className="btn btn-primary"
                style={{ width: "100%", height: "3rem" }}
              >
               {!props.isSubmitting ?  'Iniciar Sesión' : <TbLoader color={'rgba(255, 255, 255, 1)'} size={'1.4rem'} className="loader_login_button" /> } 
              </button>
            </div>
              </div>
              </Form>
                )}
             </Formik>
            </div>
            <p>¿No eres {role}?</p>
            {role !== 'representante de naviera' && <button className="btn btn-link mb-3" onClick={() => setRole('representante de naviera')}>Ingresar como representante de naviera</button>}
            {role !== 'miembro AAAPVER' && <button className="btn btn-link mb-3" onClick={() => setRole('miembro AAAPVER')}>Ingresar como miembro AAAPVER</button>}
            {role !== 'agente aduanal' && <button className="btn btn-link mb-3" onClick={() => setRole('agente aduanal')}>Ingresar como miembro agente aduanal</button>}
          </div>
        </div>
      </div>
  );
};

export default Login;
